import { createFileRoute } from '@tanstack/react-router';
import Reports from '../../../administration/src/components/Apps/AppDetails/Reports';
import { withModalOutlet } from '../-withModalOutlet';

export const Route = createFileRoute('/_secured/administration/apps/$appId/reports')({
  component: withModalOutlet(Reports),
});
